import request from "@/utils/request";

/**
 * Guides d'utilisation — source de vérité : `resources/guides/*.md` côté backend.
 *
 * L'API ne renvoie que les fiches auxquelles le compte connecté a droit : le
 * front affiche ce qu'il reçoit et ne refait aucun filtrage de permissions.
 *
 * L'endpoint s'appelle `/api/guides` : `/api/documentation` est déjà pris par
 * l'UI Swagger du backend (l5-swagger), qui y répond en HTML.
 */
export const documentationApi = {
    /** Catalogue visible par le compte connecté (métadonnées seules). */
    index() {
        return request.get("/api/guides");
    },

    /** Contenu d'une fiche, déjà rendu et assaini côté serveur. */
    show(slug) {
        return request.get(`/api/guides/${slug}`);
    }
};
